<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Property</th>
          <th class="text-left">Value</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="key in entity_keys" :key="key.name">
          <router-link :to="{name: 'metric', params: { entityId: entity.entity_id, metricName:key.name,tableName: key.value.table_name }}">
          <td>{{ key.name }}</td>
          </router-link>
          <td>{{ key.value }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
  export default {
    name: 'EntityMetrics',
    props: {
      entity: {
        type: Object,
        required: true
      },
      exclude: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({
    }),
    computed:{
      entity_keys() {
        let metric_list = []
        var obj = this.entity.field_mappings
        for (const prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            if(!this.exclude.includes(prop)) {
              metric_list.push({name: prop, value: obj[prop]})
            }
          }
        }
        metric_list.sort(function (a,b) {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();

          let comparison = 0;
          if (nameA > nameB) {
            comparison = 1;
          } else if (nameA < nameB) {
            comparison = -1;
          }
          return comparison;

        })
        return metric_list

      }
    }
    ,
    mounted() {
      console.log("Entity Metrics")
      console.log(this.entity)
    },

  }
</script>
